import React from 'react';
import './App.css';

const App: React.FC = () => {
  return (
    <div className="App">
      <div className="header">
        Home page
      </div>
    </div>
  );
}

export default App;
